import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../api/axios';
import Toast from './Toast';

const TYPES = ['Bug Report', 'Feature Request', 'General'];

export default function FeedbackButton() {
  const [open, setOpen]       = useState(false);
  const [type, setType]       = useState('General');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [toast, setToast]     = useState(null);
  const location              = useLocation();

  const submit = async () => {
    if (message.trim().length < 10) return;
    setSending(true);
    try {
      await api.post('/feedback', { type, message: message.trim(), page: location.pathname });
      setToast({ message: 'Thanks for your feedback!', type: 'success' });
      setOpen(false);
      setMessage('');
      setType('General');
    } catch {
      setToast({ message: 'Failed to send feedback. Please try again.', type: 'error' });
    }
    setSending(false);
  };

  return (
    <>
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      {/* Floating button */}
      <button
        onClick={() => setOpen(true)}
        style={{
          position: 'fixed', bottom: 24, right: 24, zIndex: 200,
          background: '#1E293B', border: '1px solid #334155', color: '#CBD5E1',
          borderRadius: 40, padding: '10px 18px', fontSize: '0.82rem', fontWeight: 600,
          cursor: 'pointer', boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
          display: 'flex', alignItems: 'center', gap: 6,
        }}
      >
        💬 Feedback
      </button>

      {/* Modal */}
      {open && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 300, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', padding: '0 24px 80px' }}>
          <div style={{ background: '#1E293B', border: '1px solid #334155', borderRadius: 16, padding: 24, width: 340, boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ fontWeight: 700, color: '#F1F5F9', fontSize: '0.95rem' }}>Send Feedback</h3>
              <button onClick={() => setOpen(false)} style={{ background: 'none', border: 'none', color: '#64748B', cursor: 'pointer', fontSize: '1rem' }}>✕</button>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: '0.78rem', color: '#94A3B8', display: 'block', marginBottom: 5 }}>Type</label>
              <select value={type} onChange={(e) => setType(e.target.value)}
                style={{ width: '100%', background: '#0F172A', border: '1px solid #334155', borderRadius: 7, padding: '8px 10px', color: '#F1F5F9', fontSize: '0.875rem' }}>
                {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: '0.78rem', color: '#94A3B8', display: 'block', marginBottom: 5 }}>Message</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={4}
                placeholder="Tell us what you think..."
                style={{ width: '100%', background: '#0F172A', border: '1px solid #334155', borderRadius: 7, padding: '8px 10px', color: '#F1F5F9', fontSize: '0.875rem', resize: 'vertical', outline: 'none', boxSizing: 'border-box' }}
              />
              <div style={{ fontSize: '0.72rem', color: message.length < 10 ? '#EF4444' : '#64748B', marginTop: 3 }}>
                {message.length < 10 ? `${10 - message.length} more characters needed` : `${message.length} characters`}
              </div>
            </div>

            <button onClick={submit} disabled={sending || message.trim().length < 10}
              style={{ width: '100%', padding: '10px', background: '#2563EB', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer', opacity: (sending || message.trim().length < 10) ? 0.6 : 1 }}>
              {sending ? 'Sending...' : 'Submit Feedback'}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
